<ng-container *ngIf="!(isPartOfArNavigation$  | async)">
    <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
</ng-container>
<ng-container *ngIf="(isPartOfArNavigation$  | async)" content [ngSwitch]="dataState">
    <div *ngSwitchCase="'loading'">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <aumico-notes-page
        *ngSwitchCase="'success'"
        [isVersionMismatch]="isVersionMismatch"
        [isSealed]="currentAnnualReport?.isSealed === true"
        [annualReportDefaultSettings]="annualReportDefaultSettings"
        [fxNotesContext]="fxNotesContext"
        [fliFxStamps]="fliFxStamps"
        [isNotesStructureToCopyFromAnotherAnnualReportNull]="isNotesStructureToCopyFromAnotherAnnualReportNull"
        [isNotesSavedBefore]="isNotesSavedBefore"
        [combination]="combination"
        [arTemplateNotesTemplateId]="arTemplateNotesTemplateId"
        [annualReportAccordionsData]="annualReportAccordions"
        [flis]="flis"
        [languages]="supportedLocales"
        [reportLocale]="reportLocale"
        [currentLanguage]="currentLanguage"
        [delegate]="this"
        [notesToBeAutoFilled]="autoFilledNotes"
        [previousYearNotes]="previousYearNotes"
        [projectsList]="projectsList$ | async"
        [activeAnnualReportEncryptedId]="activeAnnualReportEncryptedId"
        [highlightTodos]="highlightTodos"
        [supportOperation]="supportOperation"
        [balanceMappingTemplate]="balanceMappingTemplate"
        [incomeMappingTemplate]="incomeMappingTemplate"
        [rawBalanceMappingTemplate]="rawBalanceMappingTemplate"
        [rawIncomeMappingTemplate]="rawIncomeMappingTemplate"
        [notesFromChosenAnnualReport]="autofilledNotesFromChosenReport"
        (copyNotesStructureFromAnotherAnnualReportButtonClicked)="onCopyNotesStructureFromAnotherAnnualReportButtonClicked()"
        (highlightTodosChanged)="onHighlightTodosChanged($event)"
        (selectedAnnualReportIdToCopyNotesStructureFromEvent)="onSelectedAnnualReportIdToCopyNotesStructureFrom($event)"
    >
    </aumico-notes-page>

    <div *ngSwitchCase="'error'" class="alert alert-danger">
        {{ 'aumico_reports_required_data_not_completed' | i18next }}
    </div>
    <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{ nextStepPrefix | i18next }}"
        nextButtonText="{{ nextStepLabel | i18next }}"
        [nextButtonAction]="proceedButtonClicked"
        nextButtonRouterLink="../{{ nextStepPath }}"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{ previousStepPrefix | i18next }}"
        backButtonText="{{ previousStepLabel | i18next }}"
        backButtonRouterLink="../{{ previousStepPath }}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
